import { cn } from '@/lib/utils';

interface FragmentBadgesProps {
  count: number;
  isSelected: boolean;
}

export const FragmentBadges = ({ count, isSelected }: FragmentBadgesProps) => {
  return (
    <div className="flex flex-wrap gap-1">
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          className={cn(
            'inline-flex size-[18px] items-center justify-center rounded-full bg-muted text-xs leading-[18px] font-normal text-primary',
            isSelected && 'text-primary'
          )}
        >
          {i + 1}
        </span>
      ))}
    </div>
  );
};
